// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Qz","center":"Rz","empty":"Sz","pending":"Tz","referralTitle":"Uz","wrapper":"Vz","title":"Wz","tabs":"Xz","tab":"Yz","active":"Zz","btn":"aA","rewards_table":"bA"};
    if(module.hot) {
      // 1715276856386
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  